import { AxiosInstance } from 'axios';
import { MeResource, PermissionContainerResource } from './resources';
import { UserRef } from './refs';

export default class Me {
    private basePath = '/api/me';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get current me info
    get = async (): Promise<MeResource> => {
        const { data } = await this.http.get(`${this.basePath}/`);

        return data;
    };

    // Get permissions schema for current user
    getPermissions = async (): Promise<PermissionContainerResource> => {
        const { data } = await this.http.get(`${this.basePath}/auth/permissions`);

        return data;
    };

    // Notify about user presence
    notifyAboutUserPresence = async (): Promise<UserRef> => {
        const { data } = await this.http.put(`${this.basePath}/presence`);

        return data;
    };
}
